import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class AdProduceService {

  constructor() { }
  private produceCreativeSource = new Subject<Array<any>>();
  produceCreativeObs = this.produceCreativeSource.asObservable();

  updateProduceCreative(val: Array<any>) {
    this.produceCreativeSource.next(val);
  }

}
